import { ArrowNarrowLeftIcon, CheckCircleIcon, ChevronRightIcon, InformationCircleIcon } from "@heroicons/react/solid";
import React, { Component, useEffect, useReducer, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import BaseView from "../components/BaseViewComponent";
import { BalanceLabel, CoinIcon, InformationBar, LoadingDialog, TotalBalanceViewWithDefi, WalletAccount_Pop_List } from "../components/CommonComponents";
import Button from "../components/control/Button";
import Selector from "../components/control/Selector";
import { MenuItem, ProfileIcon, ProfileMenu } from "../components/ProfileMenu";
import { Icon_Copy, Icon_Hide, Icon_History, Icon_Info, Icon_Lock_Closed, Icon_Setting, Icon_Show } from "../components/Svgs";
import DataCenter, { CurrentCurrency, QuoteCoinID, TransactionMethod } from "../modules/DataCenter";
import { WalletInfo, WalletService } from "../modules/WalletService";
import { Events, JSEvent } from "../utils/JSEvent";
import { LoadingSVG } from "../components/Svgs"
import iconWallet from '../images/icon-wallet.svg';
import { createModalDialog, useModalDialog } from "../components/ModalDialog";
import ClipboardJS from 'clipboard';
import { ToastType, useToast } from "../components/Toast";
import BigNumber from "bignumber.js";
import { IsFunctionOpen, WalletAccount } from "../conf/Config";
import { WithdrawView } from "./WithdrawView";
import { Localize, LocalStr } from "../modules/localize/Localize";
import { usePopWindow } from "../components/BottomPopWindow";
import { TopupView } from "./TopupView";
import { DoingTransactions, TransactionHistory_View } from "./TransactionOrderView";
import MetaVirusNFT from "../modules/MetaVirusNft";

const WalletDialog = createModalDialog("dialog-wallet-msg")

export default class WalletView extends BaseView {
    constructor(props) {
        super(props)
    }

    render() {
        return <div className="flex flex-col w-full h-full bg-white">
            <div className="flex-col flex justify-start items-center pt-3 w-full h-full">
                <WalletTitle addView={this.addView} />
                <WalletContent addView={this.addView} />
            </div>
            {this.state.views}
            <WalletDialog />
        </div>
    }
}

const WalletTitle = ({ addView }) => {
    const onViewAction = (action) => {
        console.log(action)
    }

    return <div className="flex px-3 flex-col w-full justify-start items-center">
        <div className="flex w-full">
            {DataCenter.showAccountInfo ?
                <ProfileIcon onClick={e => {
                    addView(ProfileMenu, "left", () => { },
                        onViewAction, {
                        addView: addView,
                    })
                }} /> : <></>}
            <LocalStr msg={Localize.UI.WalletView.defiWallet} className="flex flex-1 pr-6 text-xl text-gray-700 font-semibold justify-center items-center" />
        </div>
    </div>
}

const WalletContent = ({ addView }) => {
    const [walletReady, setWalletReady] = useState(false);
    const [walletInfo, setWalletInfo] = useState(null);

    const onWalletCreated = (walletInfo) => {
        setWalletInfo(walletInfo);
    }

    const onWalletReset = () => {
        setWalletInfo(null);
    }

    const onWalletServiceReady = () => {
        setWalletReady(true);
    }

    useEffect(() => {
        JSEvent.on(Events.Wallet.Created, onWalletCreated);
        JSEvent.on(Events.Wallet.Reset, onWalletReset);
        if (WalletService.ready) {
            setWalletReady(true);
            if (WalletService.walletInfo)
                setWalletInfo(WalletService.walletInfo);
        } else {
            JSEvent.on(Events.Wallet.Ready, onWalletServiceReady);
        }
        return () => {
            JSEvent.remove(Events.Wallet.Ready, onWalletServiceReady);
            JSEvent.remove(Events.Wallet.Created, onWalletCreated);
            JSEvent.remove(Events.Wallet.Reset, onWalletReset);
        }
    }, []);

    // if (WalletService.walletInfo == null) {
    //     const walletInfo = WalletService.createWallet();
    // }

    let page = null;
    if (!walletReady) {
        page = <div className="flex w-full h-full justify-center items-center">{LoadingSVG}</div>
    } else if (walletInfo == null) {
        page = <CreateWalletPage addView={addView} />
    } else {
        page = <WalletPage addView={addView} walletInfo={walletInfo} />
    }

    return <div className="flex flex-col w-full h-full bg-white items-center pt-4">
        {page}
    </div>
}


const CreateWalletPage = ({ addView }) => {

    const [loading, setLoading] = useState(false);

    const createWallet = () => {
        setLoading(true);
        WalletService.createWallet().then(wi => {
            setLoading(false);
        });
    }

    return <div className="flex flex-col w-full h-full justify-start items-center px-7">
        <div className="flex flex-col w-full pt-14 pb-20 bg-gray-100 rounded-2xl justify-center items-center">
            <img className="w-24" src={iconWallet}></img>
            <LocalStr msg={Localize.UI.CreateWalletView.welcome} className="text-xl font-semibold pt-4" />
        </div>
        <div className="flex flex-col w-full pb-10 flex-1 justify-end">
            <Button name="L:UI.CreateWalletView.create" widthStyle="w-full" type="primary" rounded="rounded-xl"
                className=" text-lg font-semibold" padding="py-2.5"
                onClicked={e => {
                    createWallet();
                }} />
            <div className=" flex w-full justify-center items-center pt-6 text-link font-semibold"
                onClick={e => {
                    addView(WalletImportPage, "left", () => { }, action => {
                        console.log(action)
                    });
                }}
            >{Localize.getMsg(Localize.UI.CreateWalletView.import)}</div>
        </div>
        <LoadingDialog show={loading} />
    </div>
}

const WalletPage = ({ addView, walletInfo }) => {

    return <div className="flex flex-col w-full h-full">
        <div className="flex flex-col w-full px-3">
            <WalletPage_Title addView={addView} walletInfo={walletInfo} />
        </div>

        <DoingTransactions addView={addView} />

        <div className="flex w-full h-[1px] bg-gray-100 "></div>
        <div className="flex flex-col flex-1 w-full bg-white overflow-hidden basis-0">
            <div className="flex flex-col w-full px-3 flex-1 overflow-y-scroll">
                <div className="flex flex-col w-full">
                    <WalletPage_Properties addView={addView} walletInfo={walletInfo} />
                </div>
            </div>
        </div>
    </div >
}

const WalletPage_Title = ({ addView, walletInfo }) => {

    // const [totalBalance, setTotalBalance] = useState("--");

    const currency = CurrentCurrency();
    // const prize = DataCenter.getQuotePrice(QuoteCoinID, currency.name).toNumber();
    const quoteCoin = DataCenter.getCoin(QuoteCoinID);

    const walletDialog = useModalDialog("dialog-wallet-msg")
    const [makeToast] = useToast();
    const [pop] = usePopWindow();

    // const updateTotalBalance = () => {
    //     if (walletInfo == null) {
    //         setTotalBalance("--");
    //     } else {
    //         setTotalBalance(walletInfo.totalBalance())
    //     }
    // }

    // const onDataUpdate = (dataName) => {
    //     if (dataName == "quotePrice") {
    //         updateTotalBalance();
    //     }
    // }

    // const onBalanceUpdate = ({ token, balance }) => {
    //     updateTotalBalance();
    // }

    // useEffect(() => {
    //     JSEvent.on(Events.DataCenter.DATA_UPDATED, onDataUpdate);
    //     JSEvent.on(Events.Wallet.BalanceUpdate, onBalanceUpdate);
    //     updateTotalBalance();
    //     return () => {
    //         JSEvent.remove(Events.DataCenter.DATA_UPDATED, onDataUpdate)
    //         JSEvent.remove(Events.Wallet.BalanceUpdate, onBalanceUpdate);
    //     }
    // }, [])

    return <><div className="flex justify-center items-center">
        <div className="text-xs text-white rounded-lg bg-gray-700 px-5 py-1">
            {/* <Selector
                options={DataCenter.blockchains}
            /> */}

            {WalletService.blockchain.text}
        </div>
    </div>
        <div className="flex flex-col w-full pt-4">
            <div className="flex text-gray-600">
                <div className="flex px-4 py-2 rounded-md bg-gray-200 h-8 items-center justify-center"
                    onClick={e => {
                        addView(WalletAddressDetail, "left", () => { }, action => { }, {
                            walletInfo: walletInfo
                        })
                    }}>
                    <div className=" text-xs whitespace-nowrap" style={{ display: "block" }}>
                        {walletInfo.ellipsisAddress(6)}
                    </div>
                    <Icon_Info className="w-8 h-8 pt-1.5 pl-1.5 pb-1.5" />
                </div>
                <div className="flex w-full justify-end items-center">

                    {
                        IsFunctionOpen("Fund") ?
                            <div className="flex rounded-md bg-gray-200 mr-4 text-xs px-3 h-8 items-center justify-center"
                                onClick={e => {
                                    pop("pop_list_walletaccount", WalletAccount_Pop_List, Localize.getMsg(Localize.COMMON.SelRecvAccount), action => {
                                        if (action.name == "select") {
                                            const item = action.value;
                                            addView(TopupView, "left", null, action => { }, {
                                                addView: addView,
                                                walletAccount: item.id
                                            });
                                        }
                                    }, { walletAccount: WalletAccount.GameAccount, includeDeFi: false, showBalance: false });
                                }}
                            >{Localize.getMsg(Localize.COMMON.Topup)}</div>
                            : <div></div>
                    }

                    <div className="flex rounded-md h-8 px-3 items-center justify-center text-xs bg-gray-200 mr-4"
                        onClick={e => {
                            addView(WithdrawView, "left", null, action => { }, {
                                addView: addView,
                                walletAccount: WalletAccount.DeFi,
                                mode: TransactionMethod.Transfer
                            });
                        }}>{Localize.getMsg(Localize.COMMON.Send)}</div>
                    <Icon_Setting className="w-8 h-8 p-1.5 rounded-md bg-gray-200" onClick={e => {
                        addView(WalletSettingPage, "left", () => { }, action => {
                        }, {
                            addView: addView,
                            walletInfo: walletInfo
                        });
                    }} />
                </div>
            </div>
            <div className="flex py-4 items-center">
                {/* <BalanceLabel className='text-2xl'
                    balance={totalBalance} decimals={quoteCoin.showDecimals} show={0}
                />
                <div className="text-2xl">{quoteCoin.name}</div>
                <div className="text-gray-500 pl-2 flex">
                    ≈
                    <BalanceLabel className=''
                        balance={totalBalance} decimals={2} show={1}
                        exchangeRate={prize} coinSymbol={currency.symbol} />
                </div> */}
                <TotalBalanceViewWithDefi balance={new BigNumber(0)} quoteCoin={quoteCoin} />
            </div>
        </div>
        <WalletDialog />
    </>
}

const WalletPage_Properties = ({ addView, walletInfo }) => {
    const [tokens, setTokens] = useState(DataCenter.getCoins());

    const onDataUpdate = ({ name, value }) => {
        if (name == "tokens") {
            setTokens(value);
        }
    }

    useEffect(() => {
        JSEvent.on(Events.Wallet.DataUpdate, onDataUpdate);

        return () => {
            JSEvent.remove(Events.Wallet.DataUpdate, onDataUpdate);
        }
    }, [])

    let coins = []
    if (tokens != null) {
        tokens.forEach(token => {
            coins.push(<WalletPage_Properties_CoinPanel key={token.id} addView={addView} walletInfo={walletInfo} token={token} />)
        })
    }
    return <div className="flex flex-col pt-4 w-full">
        <div className="flex">
            <LocalStr msg={Localize.UI.WalletView.assets} className="text-xl font-semibold" />
            <div className="flex flex-1 items-center justify-end w-8 h-8 p-1" onClick={e => {
                addView(TransactionHistory_View, "left", null, action => {

                }, { addView: addView })
            }}><Icon_History className="w-8 h-8 p-1" /></div>
        </div>
        {coins}
        {/* <div className="flex">
            <LocalStr msg={Localize.UI.WalletView.nfts} className="text-xl font-semibold" />
            <div className="flex flex-1 items-center justify-end w-8 h-8 p-1" onClick={e => {
                // addView(TransactionHistory_View, "left", null, action => {

                // }, { addView: addView })
            }}></div>
            <WalletPage_Properties_Nfts walletInfo={walletInfo} addView={addView} />
        </div> */}
    </div>
}

const WalletPage_Properties_Nfts = ({ addView, walletInfo }) => {
    // const nft = new MetaVirusNFT();
    // nft.getNfts(walletInfo.address);
    return <div>

    </div>
}

const WalletPage_Properties_CoinPanel = ({ addView, walletInfo, token }) => {

    const [tokenBalance, setTokenBalance] = useState("--");

    const currency = CurrentCurrency();
    const price = DataCenter.getCoinQuotePrice(token.id, QuoteCoinID, currency.name);

    const coin = DataCenter.getCoin(token.id);

    const updateBalance = () => {
        walletInfo.balance(token).then(r => {
            setTokenBalance(r.toTrimed(2, coin.showDecimals));
        }, err => {

        });
    }

    const onBalanceUpdate = (evt) => {
        if (token.id == evt.token.id) {
            updateBalance();
        }
    }

    useEffect(() => {
        JSEvent.on(Events.Wallet.BalanceUpdate, onBalanceUpdate);
        updateBalance();
        return () => JSEvent.remove(Events.Wallet.BalanceUpdate, onBalanceUpdate);
    }, [])

    return <div className="flex w-full justify-start items-center py-4">
        <CoinIcon coin={token} className="w-8 h-8" />
        <div className="flex flex-1 flex-col pl-2">
            <div className="font-semibold">{tokenBalance} {token.name}</div>
            <div className="text-sm text-gray-400">{token.fullName}</div>
        </div>
        <div className="flex items-center font-semibold">{currency.symbol}{
            tokenBalance == "--" ? "--" : price.times(new BigNumber(tokenBalance)).toCurrencyFixed(currency.decimals)
        }</div>
    </div>
}

const WalletAddressDetail = ({ walletInfo, fireViewAction }) => {
    const [makeToast] = useToast();
    const [closing, setClosing] = useState(false);
    const copy = new ClipboardJS(".copy-address")


    return <div className="flex flex-col w-full h-full">
        <div className="flex flex-col w-full h-56 bg-white p-4 mt-24 items-center justify-center">
            <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
                <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                    aria-hidden="true" />
                <LocalStr msg={Localize.COMMON.walletAddress} className="flex flex-1 font-semibold justify-center items-center pr-6" />
            </div>
            <div className="flex text-xs items-center justify-center w-full">{walletInfo.address}</div>

            <InformationBar text={WalletService.blockchain.addressTip} />

            <div className="copy-address mt-4 px-4 py-2 w-full bg-primary flex items-center rounded-md justify-center"
                data-clipboard-text={walletInfo.address}
                onClick={e => {
                    if (!closing) {
                        setClosing(true);
                        fireViewAction({ name: "close" })
                        makeToast(Localize.getMsg(Localize.UI.WalletView.addressCopied), ToastType.right)
                    }
                }}
            >{Localize.getMsg(Localize.UI.WalletView.copyAddress)}</div>
        </div>
    </div>
}

const WalletImportPage = (props) => {
    const [makeToast] = useToast();
    const walletDialog = useModalDialog("dialog-wallet-msg")
    const ref = useRef();
    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => props.fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" />
            <LocalStr msg={Localize.UI.CreateWalletView.import} className="flex flex-1 font-semibold justify-center items-center pr-6" />
        </div>
        <div className="w-full flex flex-col h-full pt-4">
            <LocalStr msg={Localize.UI.CreateWalletView.inputPhrase} className="font-semibold text-xl" />
            <LocalStr msg={Localize.UI.CreateWalletView.inputPhraseTip} className="text-sm text-gray-400" />
            <textarea ref={ref} className=" outline-none resize-none py-2 px-4 mt-4 bg-gray-50 rounded-xl h-32"
                placeholder={Localize.getMsg(Localize.UI.CreateWalletView.inputTip)}
            />
            <div className="flex flex-col w-full flex-1 justify-end pb-8">
                <Button name="导入" widthStyle="w-full" type="primary" rounded="rounded-xl"
                    className=" text-lg font-semibold" padding="py-2.5"
                    onClicked={e => {
                        const mnemonic = ref.current.value;
                        if (mnemonic.length > 0) {
                            WalletService.importWallet(mnemonic).then(
                                wi => {
                                    const args = {
                                        title: <div className="flex">
                                            <CheckCircleIcon className="w-6 h-6 text-clr-right" /><div className="pl-2">导入成功</div>
                                        </div>,
                                        context: Localize.getMsg(Localize.UI.CreateWalletView.importSuccess),
                                        buttons: [
                                            { id: "reset", name: "L:COMMON.ok", type: "primary", action: "close" },
                                        ]
                                    }
                                    walletDialog.show(args).then(b => {
                                        props.clearView();
                                    })
                                },
                                err => {
                                    makeToast(Localize.getMsg(Localize.UI.CreateWalletView.wrongPhrase), ToastType.wrong, "toast-mnemonic-error");
                                }
                            )
                        }
                    }} />
            </div>
        </div>
    </div>
}

const WalletSettingPage = ({ addView, fireViewAction, walletInfo }) => {
    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" />
            <LocalStr msg={Localize.COMMON.Setting} className="flex flex-1 font-semibold justify-center items-center pr-6 text-xl" />
        </div>

        <div className="flex flex-col w-full mt-4" onClick={e => {
            addView(WalletPrivateKeyPage, "left", () => { }, action => {
            }, {
                walletInfo: walletInfo
            });
        }}>
            <div className="flex w-full">
                <div className="flex flex-col w-full">
                    <LocalStr msg={Localize.UI.WalletView.privateKey} className="font-semibold" />
                    <LocalStr msg={Localize.UI.WalletView.recoveryPkTip} className="text-xs text-gray-400 pt-2" />
                </div>
                <div className="flex justify-center items-center"><ChevronRightIcon className="w-5 h-5 text-gray-500" /></div>
            </div>
            <div className="flex bg-gray-100 my-4 w-full h-[1px]"></div>
        </div>

        {/* <div className="flex flex-col w-full mt-4" onClick={e => {
            addView(WalletMnomeicPage, "left", () => { }, action => {
            }, {
                walletInfo: walletInfo
            });
        }}>
            <div className="flex w-full">
                <div className="flex flex-col w-full">
                    <LocalStr msg={Localize.UI.WalletView.recoveryPhrase} className="font-semibold" />
                    <LocalStr msg={Localize.UI.WalletView.recoveryTip} className="text-xs text-gray-400 pt-2" />
                </div>
                <div className="flex justify-center items-center"><ChevronRightIcon className="w-5 h-5 text-gray-500" /></div>
            </div>
            <div className="flex bg-gray-100 my-4 w-full h-[1px]"></div>
        </div> */}

        {/** Reset Wallet 功能暂时关闭 */}
        {/* <div className="flex flex-col w-full" onClick={e => {
            addView(WalletResetPage, "left", () => { }, action => {
            }, {
                walletInfo: walletInfo
            });
        }}>
            <div className="flex w-full">
                <div className="flex flex-col w-full">
                    <LocalStr msg={Localize.UI.WalletView.resetWallet} className="font-semibold" />
                    <LocalStr msg={Localize.UI.WalletView.resetTip} className="text-xs text-gray-400 pt-2" />
                </div>
                <div className="flex justify-center items-center"><ChevronRightIcon className="w-5 h-5 text-gray-500" /></div>
            </div>
            <div className="flex bg-gray-100 my-4 w-full h-[1px]"></div>
        </div> */}
    </div>
}

const WalletPrivateKeyPage = ({ addView, fireViewAction, walletInfo }) => {
    const [makeToast] = useToast();
    const [show, setShow] = useState(false);
    const [copied, setCopied] = useState(false);

    const copy = new ClipboardJS(".copy-address")
    copy.on('success', e => {
        setCopied(true);
    })

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" />
            <LocalStr msg={Localize.UI.WalletView.privateKey} className="flex flex-1 font-semibold justify-center items-center pr-6 text-xl" />
        </div>

        <div className="flex px-4 py-2 rounded-md text-xs bg-gray-100 text-gray-800 mt-4">
            <div className="pr-1 text-link"><InformationCircleIcon className="w-6 h-6" /></div>
            <LocalStr msg={Localize.UI.WalletView.phrasePkTip} />
        </div>

        {
            show ? <div className="flex flex-col px-4 py-4 rounded-2xl bg-gray-100 mt-4 w-full h-40 justify-center items-center">
                <div className="text-md font-semibold flex flex-1 break-words break-all">{walletInfo.privateKey.slice(2)}</div>
                <div className="w-full text-gray-500 flex justify-start items-center" >
                    <div
                        data-clipboard-text={walletInfo.privateKey.slice(2)}
                        className="copy-address"
                        type="button"
                    >
                        <Icon_Copy className="w-6 h-6" onClick={e => {
                            if (!copied)
                                makeToast(Localize.getMsg(Localize.UI.WalletView.phraseCopied), ToastType.right)
                        }} />
                    </div>

                    <div className="flex-1 flex justify-end">
                        <Icon_Show className="w-6 h-6" onClick={e => {
                            setShow(false);
                            setCopied(false);
                        }} />
                    </div>
                </div>
            </div> : <div className="flex flex-col px-4 py-4 rounded-2xl bg-gray-100 mt-4 w-full h-40 justify-center items-center"
                onClick={e => {
                    setShow(true);
                }}>
                <Icon_Hide className=" text-gray-400 w-12 h-12" />
                <LocalStr msg={Localize.UI.WalletView.phrasePkShow} className="font-semibold" />
                <LocalStr msg={Localize.UI.WalletView.phraseScreen} className="text-sm text-gray-400" />
            </div>
        }
    </div >
}


const WalletMnomeicPage = ({ addView, fireViewAction, walletInfo }) => {
    const [makeToast] = useToast();
    const [show, setShow] = useState(false);
    const [copied, setCopied] = useState(false);

    const copy = new ClipboardJS(".copy-address")
    copy.on('success', e => {
        setCopied(true);
    })

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" />
            <LocalStr msg={Localize.UI.WalletView.recoveryPhrase} className="flex flex-1 font-semibold justify-center items-center pr-6 text-xl" />
        </div>

        <div className="flex px-4 py-2 rounded-md text-xs bg-gray-100 text-gray-800 mt-4">
            <div className="pr-1 text-link"><InformationCircleIcon className="w-6 h-6" /></div>
            <LocalStr msg={Localize.UI.WalletView.phraseTip} />
        </div>

        {
            show ? <div className="flex flex-col px-4 py-4 rounded-2xl bg-gray-100 mt-4 w-full h-40 justify-center items-center">
                <div className="text-md font-semibold flex flex-1">{walletInfo.mnemonic}</div>
                <div className="w-full text-gray-500 flex justify-start items-center" >
                    <div
                        data-clipboard-text={walletInfo.mnemonic}
                        className="copy-address"
                        type="button"
                    >
                        <Icon_Copy className="w-6 h-6" onClick={e => {
                            if (!copied)
                                makeToast(Localize.getMsg(Localize.UI.WalletView.phraseCopied), ToastType.right)
                        }} />
                    </div>

                    <div className="flex-1 flex justify-end">
                        <Icon_Show className="w-6 h-6" onClick={e => {
                            setShow(false);
                            setCopied(false);
                        }} />
                    </div>
                </div>
            </div> : <div className="flex flex-col px-4 py-4 rounded-2xl bg-gray-100 mt-4 w-full h-40 justify-center items-center"
                onClick={e => {
                    setShow(true);
                }}>
                <Icon_Hide className=" text-gray-400 w-12 h-12" />
                <LocalStr msg={Localize.UI.WalletView.phraseShow} className="font-semibold" />
                <LocalStr msg={Localize.UI.WalletView.phraseScreen} className="text-sm text-gray-400" />
            </div>
        }
        <LocalStr msg={Localize.COMMON.backup} className="text-xl font-semibold flex mt-4" />
        <div className="w-full flex text-xs rounded-md text-link justify-start items-center mt-4 px-4 py-2 bg-link bg-opacity-10">
            <InformationCircleIcon className="w-6 h-6" />{Localize.getMsg(Localize.UI.WalletView.backupTip)}
        </div>
        {/* <div className=" font-semibold flex mt-4">手动备份</div>
        <div className="text-gray-400 text-xs pt-1">请将您的助记词保存在不同的地方（例如一张纸上）以保证您的钱包安全。</div> */}
    </div >
}

const WalletResetPage = ({ addView, fireViewAction, walletInfo, clearView }) => {

    const walletDialog = useModalDialog("dialog-wallet-msg")

    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                aria-hidden="true" />
            <LocalStr msg={Localize.UI.WalletView.resetWallet} className="flex flex-1 font-semibold justify-center items-center pr-6 text-xl" />
        </div>
        <LocalStr msg={Localize.UI.WalletView.resetMsg} className="text-sm text-gray-400 pt-4 flex-1" />

        <Button widthStyle="w-full" className="font-semibold" name="L:UI.WalletView.btnReset" type="primary" onClicked={e => {
            const args = {
                title: <div className="flex">
                    <InformationCircleIcon className="w-6 h-6 text-link" /><LocalStr msg={Localize.UI.WalletView.dialogResetTitle} className="pl-2" />
                </div>,
                context: Localize.getMsg(Localize.UI.WalletView.dialogResetMsg),
                buttons: [
                    { id: "reset", name: "L:UI.WalletView.dialogBtnReset", type: "primary", action: "close" },
                    { id: "cancel", name: "L:COMMON.cancel", action: "close" }
                ]
            }
            walletDialog.show(args).then(b => {
                if (b.id == "reset") {
                    WalletService.resetWallet();
                    clearView();
                }
            });
        }} />
    </div>
}